import { Project } from '@/domain/project/Project';
import { LocalDate } from '@/domain/date/LocalDate';
import { Mission } from '@/domain/project/Mission';
import { InvalidRestMission } from '@/secondary/project/InvalidRestMission';

export interface RestProject {
  id: number;
  shortTitle: string;
  fullTitle: string;
  acronym: string;
  researchUnits: number[];
  thematics: number[];
  startDate?: string;
  endDate?: string;
  description: string;
  url: string;
  referentLastName: string;
  referentFirstName: string;
  referentEmail: string;
  countries: string[];
  locations: string[];
  frenchPartners: string[];
  foreignPartners: string[];
  funders: string[];
  missions: string[];
  educationLevel: string;
  involvedSchool: string;
  internationalAgreement: string;
  owner: number;
}

const toMission = (restMission: string): Mission => {
  switch (restMission) {
    case 'RECHERCHE':
      return Mission.RECHERCHE;
    case 'DIFFUSION':
      return Mission.DIFFUSION;
    case 'EXPERTISE':
      return Mission.EXPERTISE;
    case 'COLLECTION':
      return Mission.COLLECTIONS;
    case 'ENSEIGNEMENT':
      return Mission.ENSEIGNEMENT;
  }
  throw new InvalidRestMission(restMission);
};

const toOptionalLocalDate = (localDateIso?: string): LocalDate | undefined => (localDateIso ? LocalDate.of(localDateIso) : undefined);

export const toProject = (restProject: RestProject): Project => ({
  id: restProject.id,
  shortTitle: restProject.shortTitle,
  fullTitle: restProject.fullTitle,
  acronym: restProject.acronym,
  researchUnits: restProject.researchUnits,
  thematics: restProject.thematics,
  startDate: toOptionalLocalDate(restProject.startDate),
  endDate: toOptionalLocalDate(restProject.endDate),
  description: restProject.description,
  url: restProject.url,
  referent: {
    lastName: restProject.referentLastName,
    firstName: restProject.referentFirstName,
    email: restProject.referentEmail,
  },
  countries: restProject.countries,
  locations: restProject.locations,
  frenchPartners: restProject.frenchPartners,
  foreignPartners: restProject.foreignPartners,
  funders: restProject.funders,
  missions: restProject.missions.map(toMission),
  educationLevel: restProject.educationLevel,
  involvedSchool: restProject.involvedSchool,
  internationalAgreement: restProject.internationalAgreement,
  owner: restProject.owner,
});
